import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRightFill = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.001 10.586c0 .89 1.077 1.337 1.707.707l2.586-2.586a1 1 0 0 0 0-1.414L7.708 4.707c-.63-.63-1.707-.184-1.707.707v5.172Z" }));
const ForwardRef = forwardRef(SvgChevronRightFill);
export default ForwardRef;
